import { Instagram as InstagramIcon } from "lucide-react"

export const InstagramHeader = () => {
  return (
    <div className="flex items-center gap-2">
      <InstagramIcon className="w-6 h-6 text-primary" />
      <h1 className="text-3xl font-bold">Gerenciador de Posts do Instagram</h1>
    </div>
  )
}